var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58203 9.66927H6.41536C8.2487 9.66927 9.16536 8.7526 9.16536 6.91927V5.08594C9.16536 3.2526 8.2487 2.33594 6.41536 2.33594H4.58203C2.7487 2.33594 1.83203 3.2526 1.83203 5.08594V6.91927C1.83203 8.7526 2.7487 9.66927 4.58203 9.66927Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.582 9.66927H17.4154C19.2487 9.66927 20.1654 8.7526 20.1654 6.91927V5.08594C20.1654 3.2526 19.2487 2.33594 17.4154 2.33594H15.582C13.7487 2.33594 12.832 3.2526 12.832 5.08594V6.91927C12.832 8.7526 13.7487 9.66927 15.582 9.66927Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.582 20.6693H17.4154C19.2487 20.6693 20.1654 19.7526 20.1654 17.9193V16.0859C20.1654 14.2526 19.2487 13.3359 17.4154 13.3359H15.582C13.7487 13.3359 12.832 14.2526 12.832 16.0859V17.9193C12.832 19.7526 13.7487 20.6693 15.582 20.6693Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58203 20.6693H6.41536C8.2487 20.6693 9.16536 19.7526 9.16536 17.9193V16.0859C9.16536 14.2526 8.2487 13.3359 6.41536 13.3359H4.58203C2.7487 13.3359 1.83203 14.2526 1.83203 16.0859V17.9193C1.83203 19.7526 2.7487 20.6693 4.58203 20.6693Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.57a8a9b2c79007d696e5c23b138d24db.svg";
export { ForwardRef as ReactComponent };